import React from 'react';
import { motion } from 'framer-motion';
import { portfolioData } from '../data/mock';

const TechStackSection = () => {
  const { techStack } = portfolioData;
  
  return (
    <section className="py-16 sm:py-20 md:py-24 px-4 sm:px-6 md:px-12 lg:px-24">
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-2"
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl" style={{ fontFamily: 'Cinzel, serif', color: 'rgba(235, 240, 250, 0.95)', fontWeight: 400 }}>
            {techStack.heading}
          </h2>
        </motion.div>
        
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="text-center mb-12"
          style={{ fontFamily: 'DM Mono, monospace', color: 'rgba(150, 170, 200, 0.7)', fontSize: '0.85rem' }}
        >
          {techStack.subtitle}
        </motion.p>
        
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 sm:gap-4">
          {techStack.items.map((tech, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: index * 0.08 }}
              whileHover={{ 
                y: -4, 
                borderColor: 'rgba(200, 215, 235, 0.35)',
                scale: 1.05
              }}
              className="stack-card p-4 sm:p-5 text-center cursor-default"
            >
              <p className="text-xs sm:text-sm md:text-base mb-1" style={{ fontFamily: 'Cinzel, serif', color: 'rgba(235, 240, 250, 0.95)', fontSize: '0.9rem' }}>
                {tech.name}
              </p>
              <p className="text-xs" style={{ fontFamily: 'DM Mono, monospace', color: 'rgba(150, 170, 200, 0.6)', fontSize: '0.65rem' }}>
                {tech.category}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechStackSection;
